module.exports = __webpack_public_path__ + "static/media/Placaj ceramic KLinker Modern Via Romana1.e1173c0e.jpg";